module.exports = __webpack_public_path__ + "img/menu_gomb_tmkk_aktiv.562e1240.png";